import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dniCuit',
})
export class DniCuitPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    // Si el valor es nulo o indefinido, devuelve un string vacío.
    if (!value) {
      return '';
    }

    // Convierte el valor a string y elimina cualquier carácter que no sea un dígito.
    const cleanedValue = String(value).replace(/\D/g, '');

    // Si tiene 11 dígitos, es un CUIT.
    if (cleanedValue.length === 11) {
      // Formato: XX-XXXXXXXX-X
      return `${cleanedValue.slice(0, 2)}-${cleanedValue.slice(2, 10)}-${cleanedValue.slice(10)}`;
    }

    // Si tiene 7 u 8 dígitos, es un DNI.
    if (cleanedValue.length === 7 || cleanedValue.length === 8) {
      // Formato con separadores de miles: XX.XXX.XXX
      return new Intl.NumberFormat('es-AR').format(Number(cleanedValue));
    }

    // Si no coincide con ninguno, devuelve el valor original sin formato.
    return String(value);
  }
}
